

/** Вкладка лог журнала в анкете слушателя */
export const CardListenerTabLogs = () => {
    return <>
        logs
    </>
}